import styled from 'styled-components';
import DatePicker from 'react-datepicker';
export const styles = {
    card: {
        backgroundColor: "#EEF2F7",
        padding: "0.8rem",
    },
    cardHeader: {
        backgroundColor: "#F8F8F9",
        fontWeight: "700",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
    },

    cardTitle: {
        fontSize: "16px",
        fontWeight: "600",
        lineHeight: "16px",
        color: "#0160F1",
    },
    cardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },


    saveDataButton: {
        alignItems: "center",
        justifyContent: "center",
    },

    tableContainer: {
        height: 700,
        width: '100%'
    },
    tableContainerCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },

    boxRow: {
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 1,

    },
    boxWidth: {
        width: 250
    },
    fileInputBox: {
        border: "1px solid #000",
        borderRadius: "5px",
        width: 250,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        marginBottom: { sm: "0.2rem" },
    },
    miniCardContainer: {
        marginTop: 2,
        alignItems: 'center',
        paddingLeft: 1
    },

    commonWidth: {
        width: 250,
        height: 40
    },
    deviderStyle: {
        marginRight: 2,
        marginLeft: 2,
        backgroundColor: "#c0c0c0",
        width: 2,
    },
    whiteBackgrnd: {
        backgroundColor: "white"
    },
    redColor: {
        color: "red"
    },
    firstCardGridStyle: {
        display: 'flex',
        justifyContent: 'center'
    },
    invoicePeriodStyle: {
        display: 'flex',
        alignItems: 'center'
    },
    toStyle: {
        fontSize: 14,
        marginTop: 1,
        marginLeft: 1
    },
    fillWithAiButton: {
        alignItems: 'center',
        flexDirection: 'column',
        display: 'flex',
        paddingTop: 3,
    },
    aiTitles: {
        paddingTop: 1,
        color: '#FA4B16',
        fontSize: 12,
        fontWeight: 'bold'
    },
    fullWidth: {
        width: '100%'
    },
    fileInputStyle: {
        border: "1px solid lightgrey",
        borderRadius: "5px",
    },
    submitBttnStyle: {
        alignItems: "center",
        justifyContent: "center",
        marginTop: 5,
    },
    downloadSampleFileBtton: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    fileStyle: {
        display: { lg: "flex", md: "flex" },
        gap: "1rem",
    },
    invoicePeriodTitle: {
        alignItems: 'center'
    },
    toTitleContainer: {
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 3
    },
    searchIConStyle: {
        position: "absolute",
        top: "50%",
        left: 10,
        transform: "translateY(-50%)",
        color: "gray",
        zIndex: 1,

    },
    supplyerCodeBox: {
        position: "relative",
        width: "100%"
    },

    saveButton: {
        alignItems: 'flex-end',
        flexDirection: 'column',
        display: 'flex',
        paddingTop: 3,
        paddingRight: 4,
    },
    locContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
    },
    assetmasterCardContent: {
        backgroundColor: "#FFFFFF",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        fontSize: 15,
    },
    dwnldAssetMasterbttnStyle: {
        display: 'flex',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        alignItems: 'center', justifyContent: 'flex-start'
    },
    assetmasterCard: {
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
    },
    buttonBox: {
        display: "flex",
        alignItems: "center",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "16px",
        marginLeft: "1rem",
    },
    gridContainer: {
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    gridItem: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 35,
    },
    textField: {
        width: '100%',
    },
    gridItemEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 35,

    },
    downloadButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    provisiontablecard: {
        backgroundColor: "#EEF2F7",
        paddingHorenztal: "0.8rem",
        paddingTop: "1.3rem",

    },
    fieldTitle: {
        // fontWeight: 'bold',
        marginBottom: '8px', // Adds space between title and field
        fontSize: '14px',
        // color: '#333',
    },
    selectField: {
        height: '40px',
        boxSizing: 'border-box',
        width: '75%'
    },

    approveProvisionButton: {
        display: 'flex',
        marginTop: 3,
        justifyContent: 'flex-end',
        alignItems: 'flex-end', // Aligns button to the bottom in its grid cell
        height: '100%', // Ensures it can align to the bottom
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        alignSelf: 'center'
    },
};
export const boxSX = {
    textDecoration: "none",
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
        color: "darkblue",
    },
};
export const StyledDatePicker = styled(DatePicker)`
    width: 109px;
    height: 40px;
    border: 1px solid ${({ disabled }) => (disabled ? '#ccc' : '#000')};
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    color: #333;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    box-sizing: border-box;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
export const StyledInvoiceDatePicker = styled(DatePicker)`
width: 250px;
    height: 40px;
    border: 1px solid ${({ disabled }) => (disabled ? '#ccc' : '#000')};
    border-radius: 4px;
    padding: 8px;
    font-size: 14px;
    color: #333;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    box-sizing: border-box;
`;





